import APPSETTINGS from '@appsettings';
// Injects the Punchlist feedback widget; it reads its config from the script tag's data attributes.
export function loadPunchlist() {
    if (!APPSETTINGS.PUNCHLIST_WIDGET_URL || !APPSETTINGS.PUNCHLIST_PROJECT_ID || !APPSETTINGS.PUNCHLIST_TOKEN)
        return;
    const script = document.createElement('script');
    script.src = APPSETTINGS.PUNCHLIST_WIDGET_URL;
    script.dataset.project = APPSETTINGS.PUNCHLIST_PROJECT_ID;
    script.dataset.token = APPSETTINGS.PUNCHLIST_TOKEN;
    document.head.appendChild(script);
}
